import { createFileRoute } from "@tanstack/react-router";
import { seo, seoLinks } from "~/utils/seo";
import { SecurityReviewBand } from "~/components/pricing/SecurityReviewBand";
import { FinalCta } from "~/components/pricing/FinalCta";

export const Route = createFileRoute("/pricing/value")({
  loader: () => ({}),
  head: () => ({
    meta: seo({
      title: "Trust — Pricing | C1",
      description:
        "Accelerate your security review with C1's compliance posture — SOC 2, ISO 27001, HIPAA + BAA, GDPR — plus Trust Center, MSA, DPA, and subprocessor details.",
      url: "/pricing/value",
    }),
    links: seoLinks({ url: "/pricing/value" }),
  }),
  component: ValuePage,
});

function ValuePage() {
  return (
    <>
      <SecurityReviewBand />
      <FinalCta />
    </>
  );
}
